import React from 'react'
import AccountCard from 'pages/account/account-details/account-card'
import useAccountDetailsStyles from 'pages/account/account-details/styles'
import AccountLinkRow from 'components/account-link-row'
import BoltIcon from 'components/material-symbol/icons/Bolt'
import { FOLLOW_UP_AUTOMATIONS_PATH } from 'pages/pga-coach/settings/follow-up-automations/constants'

// Automations and their results live only in Settings; this is the way there.
const AutomationsLinkCard = () => {
  const accountClasses = useAccountDetailsStyles()

  return (
    <AccountCard title="Automations" classes={accountClasses}>
      <AccountLinkRow
        to={FOLLOW_UP_AUTOMATIONS_PATH}
        icon={<BoltIcon />}
        title="Follow-up automations"
        description="Choose which follow-ups send automatically and edit the messages."
      />
    </AccountCard>
  )
}

export default AutomationsLinkCard
